import { useQuery } from '@tanstack/react-query';
import { userManagementService } from '../services/userManagementService';

export const useUser = (userId: number | null | undefined) => {
  return useQuery({
    queryKey: ['user', userId],
    queryFn: () => userManagementService.getUserById(userId!),
    enabled: !!userId,
    staleTime: 0, // Always fetch fresh data
    refetchOnMount: true,
  });
};
